var render = function render(){var _vm=this,_c=_vm._self._c;return _c('module-template',{attrs:{"id":"scrolltainer","title":_vm.$t('global.menu.administration.roles'),"canCreate":"","createToolTip":_vm.$t('global.header.new', [_vm.$t('global.concepts.sysrole').toLowerCase()])},on:{"newItem":_vm.create}},[(_vm.roles)?_c('roles-table',{attrs:{"roles":_vm.roles}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }